import store from "@/store";
// 租付类型配置
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  editBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  labelWidth: 160,
  border: true,
  index: true,
  selection: false,
  viewBtn: false,
  delBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  rowKey: 'index',
  column: [
    {
      // 新增/修改
      label: '产品类型',
      prop: 'productId',
      type: 'select',
      editDisabled: true,
      display: true,
      dicData: store.getters.porductTypes,
      props: {
        label: 'productName',
        value: 'id',
        res: 'data.data',
      },
      hide: true,
      search: true,
      searchOrder: 1000,
      span: 24,
      rules: [
        {
          required: true,
          message: '请选择产品类型',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '产品类型',
      prop: 'productName',
      display: false,
      search: false
    },
    {
      label: '租付类型',
      prop: 'type',
      type: 'select',
      search: true,
      editDisplay: true,
      addDisplay: true,
      span: 24,
      dicData: [
        {
          label: '先付后租',
          value: 0,
        },
        {
          label: '先租后付',
          value: 1,
        },
      ],
      rules: [
        {
          required: true,
          message: '请选择租付类型',
          trigger: 'blur',
        },
      ],
      formatter: (row, value) => {
        if (value == -1) return '无'
        return ['先付后租', '先租后付'][value]
      }
    }
  ],
};
